// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "304" ? "rich-text-editor" : chunkId) + "." + {"304": "700b5822b6743024","754": "54fb873739ea5474",}[chunkId] + ".js"
}